<template>
  <section-page :title="title" style="position: relative">
    <template v-slot:right>
      <button-link
        v-if="isSmrtPhone"
        @click="syncNumbers"
      >Sync Numbers with smrtPhone</button-link>
    </template>

    <app-loading-section
      :loading="loading"
      :count="phoneNumbers.length"
      heading="You have no numbers yet"
    >
      <b-table :data="phoneNumbers">
        <b-table-column label="Label" field="label" sortable v-slot="props">
          {{ props.row.label }}
        </b-table-column>

        <b-table-column label="Number" field="number" sortable v-slot="props">
          {{ $utils.formatNumber(props.row.number) }}
        </b-table-column>

        <b-table-column label="Campaign" field="campaign_id" sortable v-slot="props">
          {{ getCampaignLabel(props.row.campaign_id) }}
        </b-table-column>

        <b-table-column label="Temp" field="temperature" sortable v-slot="props">
          {{ getTemperatureLabel(props.row.temperature) }}
        </b-table-column>

        <b-table-column label="Create Lead" field="creates_records" sortable v-slot="props">
          {{ props.row.creates_records ? "Yes" : "No" }}
        </b-table-column>

        <b-table-column cell-class="action_cell" width="80" v-slot="props">
          <button-link @click="openNumberModal(props.row)">Manage</button-link>
        </b-table-column>
      </b-table>
    </app-loading-section>

    <modal-container>
      <!--Manage Number Modal-->
      <modal-crud-form
        ref="numberModal"
        title="Phone Number"
        form-component="integration-phone-number-form"
        @close="selectedPhoneNumber = null"
      ></modal-crud-form>
    </modal-container>
  </section-page>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import api from "../../../api";

export default {
  name: "PhoneNumbersSettings",
  props: {
    type: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      default: "Numbers",
    },
    detailed: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      selectedPhoneNumber: null,
      integrationPhoneNumbers: [],
    }
  },
  mounted() {
    this.getNumbers();
  },
  computed: {
    isSmrtPhone() {
      return this.type === ENUMS.IntegrationTypeEnum.SmrtPhone.value;
    },
    isPartnerPortalCallRailPhone() {
      return this.type === ENUMS.IntegrationTypeEnum.PartnerPortalCallRail.value;
    },
    isCallRailPhone() {
      return this.type === ENUMS.IntegrationTypeEnum.CallRail.value;
    },
    phoneNumbers() {
      return this.integrationPhoneNumbers.filter(number => {
        const integration = this.$store.getters.integrations.find(integration => integration.id === number.integration_id);

        if(integration) {
          return integration.type === this.type;
        }

        return false;
      });
    }
  },
  methods: {
    syncNumbers() {
      this.loading = true;

      return api.smrtPhone.syncSmrtPhoneNumbers().then(response => {
        this.integrationPhoneNumbers = response.data;
      }).finally(() => this.loading = false);
    },
    getNumbers() {
      this.loading = true;

      api.integrationPhoneNumbers.all().then(response => {
        this.integrationPhoneNumbers = response.data;
      }).finally(() => this.loading = false);
    },
    openNumberModal(phoneNumber) {
      this.selectedPhoneNumber = phoneNumber;
      this.$refs.numberModal.open(this.selectedPhoneNumber);
    },
    getCampaignLabel(campaignId) {
      const campaign = this.$store.getters.campaigns.find(c => c.id === campaignId);

      if (campaign) {
        return campaign.label;
      }

      return "--";
    },
    getTemperatureLabel(temp) {
      return this.$utils.newGetEnumLabel(temp, ENUMS.TemperatureEnum);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

::v-deep .detail-container {
  padding: 0 1rem!important;
}

.stat {
  max-width: 300px;
  margin: 0 auto;
}

.stat--label {
  font-size: 1.375rem;
  color: $text-muted;
}

.stat--amount {
  margin-left: 10px;
  font-size: 0.75rem;
  color: $text-light;

  &.total {
    padding-left: 20px;
    border-left: 1px solid $light-grey;
  }

  &--value {
    margin-top: 4px;
    font-size: 2rem;
    color: $text;
    font-weight: bold;
    text-align: right;
  }
}
</style>
